import {
  MailIcon,
  PhoneIcon,
  ChatAlt2Icon,
  ClockIcon,
} from "@heroicons/react/solid";

const phoneDisplay = "+91 9573070830";
const phoneRaw = "919573070830";
const email = "loganoverseas@gmail.com";

const contactOptions = [
  {
    label: "Phone",
    value: phoneDisplay,
    href: `tel:+${phoneRaw}`,
    icon: PhoneIcon,
  },
  {
    label: "WhatsApp",
    value: phoneDisplay,
    href: `https://wa.me/${phoneRaw}`,
    icon: ChatAlt2Icon,
  },
  {
    label: "Email",
    value: email,
    href: `mailto:${email}`,
    icon: MailIcon,
  },
];

export default function Contact() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-950">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto grid max-w-6xl gap-10 px-5 py-12 sm:px-6 lg:grid-cols-[1fr_420px] lg:py-16">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[3px] text-cyan-700">
              Contact AbroadJacks
            </p>
            <h1 className="mt-3 max-w-3xl text-3xl font-semibold leading-tight text-slate-950 md:text-5xl">
              Talk to us about your study abroad plans.
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-7 text-slate-600">
              Reach AbroadJacks by phone, WhatsApp, or email for student enquiries, consultancy listings, and platform support.
            </p>
          </div>

          <div className="rounded-lg border border-slate-200 bg-slate-50 p-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-950 text-white">
                <ClockIcon className="h-5 w-5" />
              </span>
              <div>
                <p className="text-sm font-semibold text-slate-950">Support Hours</p>
                <p className="text-sm text-slate-600">Monday to Saturday, 10:00 AM to 7:00 PM IST</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-10 sm:px-6">
        <div className="grid gap-4 md:grid-cols-3">
          {contactOptions.map((option) => {
            const Icon = option.icon;
            return (
              <a
                key={option.label}
                href={option.href}
                target={option.label === "WhatsApp" ? "_blank" : undefined}
                rel={option.label === "WhatsApp" ? "noreferrer" : undefined}
                className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:border-cyan-300 hover:shadow-md"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-cyan-50 text-cyan-700">
                  <Icon className="h-5 w-5" />
                </span>
                <p className="mt-5 text-sm font-semibold uppercase tracking-[2px] text-slate-500">
                  {option.label}
                </p>
                <p className="mt-2 break-words text-lg font-semibold text-slate-950">
                  {option.value}
                </p>
              </a>
            );
          })}
        </div>

        <div className="mt-8 rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
          <h2 className="text-xl font-semibold text-slate-950">Send Your Enquiry</h2>
          <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-600">
            Include your preferred study destination, intake, current education level, and the city you are applying from. This helps us route your enquiry faster.
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <a
              href={`https://wa.me/${phoneRaw}`}
              target="_blank"
              rel="noreferrer"
              className="rounded-lg bg-slate-950 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800"
            >
              Message on WhatsApp
            </a>
            <a
              href={`mailto:${email}`}
              className="rounded-lg border border-slate-300 px-4 py-2.5 text-sm font-semibold text-slate-900 transition hover:bg-slate-50"
            >
              Email Us
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
